
class CapViewVehicleInfo {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_vehicle_info'
}

function create(config) {
  return new CapViewVehicleInfo(config)
}

export default {
  key,
  create,
}
